module.exports = __webpack_public_path__ + "static/media/pk_hunt.321bb357.jpg";